import React, { Component } from 'react';
import classNames from 'classnames';
import MoVeInMobileHeader from '../../../../../common/components/MoVeInMobileHeader';
import MoVeInMobileFooter from "../../../../../common/components/MoVeInMobileFooter";
import RegForm from '../RegForm';
import RegCheckData from '../RegCheckData';
import RegDone from '../RegDone';

import './MobileReg.css';

export default class MobileReg extends Component {
  render() {
    const { step } = this.props;

    return (
      <div className="MobileReg">
        <MoVeInMobileHeader />
        <div className="RegSteps">
          <div className={classNames({ hiddenStep: step !== 'check' })}>
            <RegCheckData onConfirm={this.props.onConfirmData} withLegal={this.props.withLegal} />
          </div>
          <div className={classNames({ hiddenStep: step !== 'form' })}>
            <RegForm onClickReg={this.props.onClickReg} form={this.props.form} />
          </div>
          {step === 'done' && <RegDone />}
        </div>
        <MoVeInMobileFooter />
      </div>
    );
  }
}
